(function () {
  const toggleItem = (item, button) => {
    const isActive = item.classList.toggle("active");

    if (button) {
      button.textContent = isActive ? "Read Less" : "Read More";
    }
  };

  const initCollapsibleContent = (section) => {
    if (!section) return;

    const items = section.querySelectorAll(".collapsible-text__item");

    items.forEach((item) => {
      const useAccordion = item.dataset.useAccordion === "true";
      const button = item.querySelector(".collapsible-text__read-more");

      if (!useAccordion) {
        item.classList.add("active");
        if (button) button.style.display = "none";
        return;
      }

      if (button) {
        button.textContent = item.classList.contains("active")
          ? "Read Less"
          : "Read More";

        button.onclick = (e) => {
          e.stopPropagation();
          toggleItem(item, button);
        };
      }
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll(".collapsible-text")
      .forEach(initCollapsibleContent);
  });

  document.addEventListener("shopify:section:load", (event) => {
    const sectionId = event.detail.sectionId;
    const section = document.querySelector(
      `.collapsible-text-${sectionId}`
    );

    if (section) {
      initCollapsibleContent(section);
    }
  });
})();